import React, { ReactElement } from 'react';

import EmptyGoodsIcon from 'assets/empty-goods-icon';

export function NoProductsIcon(): ReactElement {
  return <EmptyGoodsIcon />;
}
